<div class="flex flex--column">
  <div class="flex">
    <button
      [ngClass]="{ 'control-box pr-xxsmall-x': buttonPadding }"
      [class.nordic-blue-900-text]="model > min"
      [class.btn--disabled]="model === min"
      (click)="decrease($event)"
      [attr.aria-disabled]="model === min"
      [attr.aria-label]="decreaseLabel"
      [attr.aria-controls]="controls"
      data-testid="plus-minus-button-decrease"
    >
      <span class="circle inline-block">
        <fcom-icon [ngClass]="iconSize" [name]="SvgLibraryIcon.MINUS_OUTLINE" />
      </span>
    </button>
    <div class="control-box align-center flex flex--column flex--center" aria-live="polite">
      <span
        class="block"
        [ngClass]="textSize"
        [class.nordic-blue-900-text]="model >= min && model > 0"
        [class.grey-600-text]="model === 0"
      >
        {{ title }}
      </span>
      @if (description) {
        <span class="block font-body-1 nordic-blue-900-text">
          {{ description | finEmpty }}
        </span>
      }
    </div>
    <button
      [ngClass]="{ 'control-box pr-xxsmall-x': buttonPadding }"
      [class.nordic-blue-900-text]="model < max"
      [class.btn--disabled]="model === max"
      (click)="increase($event)"
      [attr.aria-disabled]="model === max"
      [attr.aria-label]="increaseLabel"
      [attr.aria-controls]="controls"
      data-testid="plus-minus-button-increase"
    >
      <span class="circle inline-block">
        <fcom-icon [ngClass]="iconSize" [name]="SvgLibraryIcon.PLUS_OUTLINE" />
      </span>
    </button>
  </div>
  @if (priceDescription) {
    <div class="flex flex--center">
      <span class="block font-body-1 nordic-blue-900-text mr-xxsmall-r">
        {{ priceDescription.text }}
      </span>
      <span [ngClass]="textSize" class="heather-700-text nowrap">{{ priceDescription.price | finPrice }}</span>
      @if (priceDescription.points) {
        <span class="font-body-1 medium-type ps-xxsmall-l flex flex--middle" data-testid="plus-minus-avios-price">
          /
          <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
          {{ priceDescription.points.amount | finPoints }}
          {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
        </span>
      }
    </div>
  }
</div>
